/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* OBELLE - Product description Lire plus / Lire moins */
(function () {
  function initObelleDescription() {
    document.querySelectorAll('.ProductMeta__Description .Rte').forEach(function (description) {
      if (description.dataset.obelleReadMore === 'true') return;

      if (description.scrollHeight <= 180) return;

      description.dataset.obelleReadMore = 'true';
      description.classList.add('obelle-description-collapsed');

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'obelle-description-toggle';
      button.textContent = 'Lire plus';
      button.setAttribute('aria-expanded', 'false');

      description.insertAdjacentElement('afterend', button);

      button.addEventListener('click', function () {
        var expanded = description.classList.toggle('obelle-description-expanded');

        description.classList.toggle('obelle-description-collapsed', !expanded);
        button.textContent = expanded ? 'Lire moins' : 'Lire plus';
        button.setAttribute('aria-expanded', String(expanded));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObelleDescription);
  } else {
    initObelleDescription();
  }

  document.addEventListener('shopify:section:load', initObelleDescription);
})();
